var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/General/Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.170246,13.6451183 L7.08775544,9.56466575 L2.99642069,13.6521902 C2.3118783,14.3381588 1.19927581,14.3381588 0.514733425,13.6521902 C-0.171577808,12.9679895 -0.171577808,11.8577104 0.514733425,11.1717418 L4.60429933,7.08244935 L0.514733425,2.99492491 C-0.171577808,2.30895628 -0.171577808,1.19867715 0.514733425,0.514476476 C1.19927581,-0.171492159 2.3118783,-0.171492159 2.99642069,0.514476476 L7.08775544,4.60200092 L11.170246,0.521548317 C11.8547884,-0.164420317 12.965622,-0.164420317 13.6519332,0.521548317 C14.3364756,1.20751695 14.3364756,2.31779608 13.6519332,3.00199676 L9.56944271,7.08421731 L13.6519332,11.1646699 C14.3382445,11.8488706 14.3382445,12.9609177 13.6519332,13.6451183 C12.9673909,14.329319 11.8547884,14.329319 11.170246,13.6451183 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2192-Referral-Programme",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Referral-Button:-Filter-Lock",
    transform: "translate(-339.000000, -21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Error",
    transform: "translate(334.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.833333, 5.833333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Error-Icon"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Gray/Gray-3",
    mask: "url(#mask-2)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.833333, -5.833333)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 25
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f817acec019d7f6dc178ed0681c37890.svg";
export { ForwardRef as ReactComponent };